/**
 * Helper function to generate OG image URL
 * Uses a single OG image for all pages
 */

const SITE_URL = "https://holaworldmigration.com.au";
const OG_IMAGE_PATH = "/og-images/og-image.png";

/**
 * Get OG image URL (single image for all pages)
 * @returns The URL to the OG image
 */
export const getOGImageUrl = (): string => {
  return `${SITE_URL}${OG_IMAGE_PATH}`;
};
